import React, { createContext } from 'react';
import useSort from 'hooks/useSort';

const SortContext = createContext();

function SortProvider({ children, data }) {
	const { sortData, setSortData } = useSort(data);

	return <SortContext.Provider value={{ sortData, setSortData }}>{children}</SortContext.Provider>;
}

export { SortContext, SortProvider };
